import {Textarea} from '@mantine/core';
import {Alert} from 'src/design/atoms/Alert';
import {Box} from 'src/design/atoms/Box';
import {Stack} from 'src/design/atoms/Stack';
import {Text} from 'src/design/atoms/Text';
import {IconInfoCircle} from '@tabler/icons-react';
import React from 'react';
import {Controller, useFormContext, useWatch} from 'react-hook-form';
import {SectionCard} from 'src/design/atoms/SectionCard';
import type {InstanceFormValues, InstanceSectionProps} from './SectionProps';

export const BannerSection: React.FC<InstanceSectionProps> = ({mode}) => {
  const {control} = useFormContext<InstanceFormValues>();
  const isViewMode = mode === 'view';
  const message = useWatch({control, name: 'bannerMessage'}) as
    | string
    | undefined;

  if (isViewMode) {
    return (
      <SectionCard title="Banner" data-testid="section-banner">
        <Box p="md">
          {message ? (
            <Alert
              color="blue"
              variant="light"
              icon={<IconInfoCircle />}>
              {message}
            </Alert>
          ) : (
            <Text size="sm" c="dimmed">
              No banner configured
            </Text>
          )}
        </Box>
      </SectionCard>
    );
  }

  return (
    <SectionCard title="Banner" data-testid="section-banner">
      <Box p="md">
        <Stack gap="md">
          <Controller
            name="bannerMessage"
            control={control}
            render={({field}) => (
              <Textarea
                data-testid="form-field-bannerMessage"
                label="Banner Message"
                description={`${(field.value || '').length} / 500`}
                placeholder="Optional message displayed to all users at the top of the screen. Leave empty to disable."
                maxLength={500}
                autosize
                minRows={2}
                maxRows={5}
                value={field.value || ''}
                onChange={e => field.onChange(e.currentTarget.value)}
                onBlur={field.onBlur}
              />
            )}
          />
          {message && (
            <>
              <Text size="sm" c="dimmed">
                Preview
              </Text>
              <Alert
                color="blue"
                variant="light"
                icon={<IconInfoCircle />}>
                {message}
              </Alert>
            </>
          )}
        </Stack>
      </Box>
    </SectionCard>
  );
};
